import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { getS3Url, uploadS3, isLinkValueRequired } from '@/util.js';
import { instBundle } from '@/axios.js';
import router from '@/router';

const axiosAdmin2 = instBundle.axiosAdmin2;

const state = {
	userCount: 0,
	isInquiry: false,
	createdDate: null,
	idNoti: null,
	idNotiSchedule: null,
	initModel: {
		isPush: true,
		isMsgBox: true,
		linkType: null,
		linkValue: '',
		type: 'all',
		isReserved: true,
		startDate: '',
		contentTitle: '',
		notiText: '',
	},
	sentDate: null,
	sendTypeList: [
		{ id: 'isPush', name: '푸시' },
		{ id: 'isMsgBox', name: '알림함' },
	],
	isPush: true,
	isMsgBox: true,
	linkType: null,
	linkValue: '',
	pushType: 'admin',
	typeList: [
		{ value: 'all', name: '전체 발송' },
		{ value: 'appoint', name: '지정 발송' },
		{ value: 'target', name: '개별 발송' },
	],
	type: 'all',
	isReservedList: [
		{ value: true, name: '예약 발송' },
		{ value: false, name: '즉시 발송' },
	],
	isReserved: true,
	startDate: '',
	contentTitle: '',
	notiText: '',
	userList: [],
	filterList: [],
	exceptedIdRegisters: [],
	bigPicture: '',
	idBrand: null,
	secondCategoryTargetId: null,
	grade: null,
	doc: null,
	addIdRegisters: [],
};

const getters = {
	sendType:
		state =>
		(type = 'id') => {
			return state.sendTypeList.reduce((acc, cur) => {
				if (state[cur.id]) acc.push(cur[type]);
				return acc;
			}, []);
		},
	validation: state => linkType => {
		try {
			if (!state.isPush && !state.isMsgBox) {
				throw '전송형태는 필수값입니다.';
			}
			if (linkType && !state.linkValue && isLinkValueRequired(linkType)) {
				throw '푸시 전송에서 해당 링크타입에 대한 링크값은 필수입니다.';
			}
			if (
				(state.type === 'target' || state.type === 'appoint') &&
				state.userCount < 1
			) {
				throw '푸시메세지를 발송할 대상을 선택해주세요.';
			}
			if (state.isReserved === true) {
				if (!state.startDate) {
					throw '예약 발송 시간을 설정해주세요.';
				}
				if (state.startDate < moment().format('YYYY-MM-DDTHH:mm')) {
					throw '발송시간을 확인해주세요';
				}
			}
			if (!state.notiText) throw '푸시 & 알림함 문구를 입력해주세요.';
		} catch (msg) {
			alert(msg);
			return false;
		}
		return confirm('푸시/알림함 발송 정보를 등록하시겠습니까?');
	},
};

const mutations = {
	init(state) {
		state.idNoti = null;
		state.idNotiSchedule = null;
		state.isPush = true;
		state.isMsgBox = true;
		state.linkType = null;
		state.linkValue = '';
		state.sentDate = null;
		state.type = 'all';
		state.isReserved = true;
		state.startDate = '';
		state.contentTitle = '';
		state.notiText = '';
		state.userList = [];
		state.createdDate = null;
		state.filterList = [];
		state.userCount = 0;
		state.exceptedIdRegisters = [];
		state.bigPicture = '';
		state.idBrand = null;
		state.secondCategoryTargetId = null;
		state.grade = null;
		//지정발송에 운영자가 추가로 추가한 유저항번
		state.addIdRegisters = [];
		state.doc = null;
	},
	mutationValue(state, mutationList) {
		mutationList.forEach(obj => {
			state[obj.key] = obj.value;
		});
	},
	initFilter(state) {
		const initModel = state.initModel;
		for (let key in initModel) {
			const value = initModel[key];
			state[key] = value;
		}
	},
	/**
	 * @description 푸시보낼 대상들을 (기존 대상 제외) 추가 한다
	 * @param {Array} userList 대상리스트
	 * @param {Object} filter 필터
	 * @param {Number} count 대상 수
	 */
	addUserList(state, args) {
		state.userList = [];
		state.userCount = 0;
		state.filterList = [];
		state.exceptedIdRegisters = [];
		if (args.exceptedIdRegisters)
			state.exceptedIdRegisters = args.exceptedIdRegisters;
		if (state.userList && state.userList.length > 0) {
			const parsedList = args.userList.filter(addUser => {
				return !state.userList.some(
					selecedUser => selecedUser.idRegister === addUser.idRegister
				);
			});
			state.userList = [...state.userList, ...parsedList];
			state.userCount += parsedList.length;
		} else {
			state.userList = args.userList;
			state.userCount += args.count;
		}
		const hasEqual = state.filterList.some(filterObj => {
			return isEqual(filterObj, args.filter);
		});
		if (!hasEqual) {
			state.filterList = [...state.filterList, args.filter];
		}
	},
	initUserList(state, list) {
		state.userList = list;
	},
	confirmDeleteUser(state) {
		state.userList = state.userList.filter(userItem => {
			if (userItem.delete === true) {
				state.exceptedIdRegisters.push(userItem.idRegister);
				state.userCount--;
				return false;
			} else {
				return true;
			}
		});
	},
	initRegisters() {
		state.userList = [];
		state.filterList = [];
		state.userCount = 0;
		state.exceptedIdRegisters = [];
		state.addIdRegisters = [];
	},
	initAppointAddUserList(state, args) {
		if (args.addIdRegisters) {
			state.addIdRegisters = args.addIdRegisters;
		}
	},
};

const actions = {
	async submit({ getters, rootState, state }, imgObj) {
		try {
			const linkType = state.linkType;
			if (!getters.validation(linkType)) return;
			const startDate = moment(
				state.startDate,
				'YYYY-MM-DDTHH:mm'
			).format('X');
			{
				const date = state.startDate ? startDate : moment().format('X');

				const {
					data: { isDuplicated },
				} = await axiosAdmin2.get(`/api/noti/start/${date}/duplicated`);
				if (
					isDuplicated &&
					!confirm(
						'설정하신 발송시간에 이미 등록된 푸시/알림함이 있습니다. 동일한 시간으로 저장하시겠습니까?'
					)
				) {
					return;
				}
			}

			const params = {
				idRegister: rootState.login.idRegister,
				isPush: state.isPush,
				isMsgBox: state.isMsgBox,
				linkType,
				linkValue: state.linkValue || null,
				type: state.type,
				startDate: state.startDate ? startDate : null,
				contentTitle: state.contentTitle,
				notiText: state.notiText,
				bigPicture: null,
				targetIdRegisters:
					state.type === 'target' || state.type === 'appoint'
						? state.userList.map(item => item.idRegister)
						: null,
				searchFilter: {
					idBrand: state.idBrand || null,
					secondCategoryTargetId:
						state.secondCategoryTargetId || null,
					grade: state.grade || null,
					addIdRegisters: state.addIdRegisters || null,
				},
			};
			if (imgObj) {
				const { data } = await getS3Url(
					imgObj.extension,
					'message_box'
				);
				await uploadS3(data, imgObj.fileObj);
				params.bigPicture = `${rootState.env.IMAGE_STORAGE_PATH}/${data.fields.key}`;
			}

			await axiosAdmin2.post('/api/noti/create', params);
			router.push(`/manage/push-manage`);
		} catch (err) {
			console.error(err);
			alert('등록이 실패했습니다. 개발팀에 문의하세요.');
		}
	},
	async inquiry({ state }, { idNoti, idNotiSchedule }) {
		state.idNoti = `${idNoti}-${idNotiSchedule}`;
		const detailData = await axiosAdmin2.get(
			`/api/noti/${idNoti}/schedule/${idNotiSchedule}`
		);
		const inquiryData = detailData.data.data[0];
		state.idNotiSchedule = inquiryData.idNotiSchedule;
		state.createdDate = moment(inquiryData.createdDate * 1000).format(
			'YYYY-MM-DD HH:mm'
		);
		state.isMsgBox = inquiryData.isMsgBox;
		state.isPush = inquiryData.isPush;
		state.linkType = inquiryData.linkType;
		state.linkValue = inquiryData.linkValue;
		state.type = inquiryData.type;
		if (state.type != 'all') {
			const { data } = await axiosAdmin2.get(
				`/api/noti/${idNoti}/schedule/${state.idNotiSchedule}/registers`
			);
			state.userList = data.data;
		}
		state.startDate = inquiryData.startDate
			? moment(inquiryData.startDate, 'X').format('YYYY-MM-DDTHH:mm')
			: '';
		state.contentTitle = inquiryData.contentTitle;
		state.notiText = inquiryData.notiText;
		state.isReserved = inquiryData.isReserved;
		state.userCount = inquiryData.registerCnt;
		state.bigPicture = inquiryData.bigPicture;

		if (inquiryData.doc) {
			state.doc = JSON.parse(inquiryData.doc);
		}
	},
	async initRegisterList({ state, commit }, list) {
		state.type = 'target';
		const params = {
			idRegisters: list,
			offset: 0,
			limit: 0,
		};
		try {
			const { data } = await axiosAdmin2.post(
				'/api/noti/registers/search',
				params
			);
			const count = data.contentTotal;
			commit('addUserList', {
				userList: data.data,
				filter: params,
				count,
			});
			if (list.length !== count) {
				alert(
					`푸시 발송 대상 중 발송이 불가한 ${list.length - count}명을 제외한 나머지 ${count}명이 추가되었습니다.`
				);
			}
		} catch (err) {
			console.error(err);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
